import React from "react";
import {renderRichText} from "gatsby-source-contentful/rich-text";

export default function PieChartSection(props) {
    return (
        <section key={props.content.id} className="piechart-section" id="token-allocation">
            <div className="container">

                <div className="row title-line">
                    <div className="col-lg-6">
                        <h2>
                            {props.content.title}
                        </h2>
                    </div>
                    <div className="col-lg-5 offset-lg-1">
                        {renderRichText(props.content.body)}
                    </div>
                </div>

                <figure className="pie-chart">
                    <div className="pie"/>
                    <div className="legend">
                        <ul>
                            { props.content.elements.map((element, index) => {
                                return (
                                    <li key={index}>
                                        {element.title}
                                        <span>
                                            <em>{element.amount}</em>
                                            {element.amountPercent}
                                        </span>
                                        {renderRichText(element.body)}
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                </figure>
            </div>
        </section>
    )
}
